const VIDEO_URL_PATTERN = /\.(mp4|m4v|webm|mov|ogv)(\?|#|$)/i;

export function isVideoUrl(url) {
  return VIDEO_URL_PATTERN.test(String(url || ''));
}

export function isVideoProject(project) {
  return project?.media_type === 'video';
}

/** Video source for a project (older records stored the video in thumbnail_url too). */
export function getProjectVideoUrl(project) {
  if (!project) return '';
  if (project.media_url) return project.media_url;
  return isVideoUrl(project.thumbnail_url) ? project.thumbnail_url : '';
}

/** Still image shown for a video project when it is not playing. */
export function getProjectPosterUrl(project) {
  const thumb = project?.thumbnail_url || '';
  if (!thumb || thumb === project?.media_url || isVideoUrl(thumb)) return '';
  return thumb;
}
